import React from 'react';
import StudioAdvisorQr, { getStudioAdvisorQrBoxSize } from './StudioAdvisorQr';

interface StudioCtaRowProps {
  qrCodeUrl?: string;
  isStory?: boolean;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

// CTA stays on the left; QR sits on the right edge (same inset as the page
// number) and shares the CTA row's vertical centre so the arrow points at it.
const StudioCtaRow: React.FC<StudioCtaRowProps> = ({ qrCodeUrl, isStory, children, style }) => {
  const gap = isStory ? 12 : 10;
  const qrSize = getStudioAdvisorQrBoxSize(isStory, 'cta');

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: qrCodeUrl ? 'space-between' : 'flex-start',
        gap,
        width: '100%',
        boxSizing: 'border-box',
        ...style
      }}
    >
      <div
        style={{
          flex: '0 1 auto',
          minWidth: 0,
          maxWidth: qrCodeUrl ? `calc(100% - ${qrSize + gap}px)` : '100%'
        }}
      >
        {children}
      </div>
      {qrCodeUrl ? <StudioAdvisorQr url={qrCodeUrl} isStory={isStory} size="cta" /> : null}
    </div>
  );
};

export default StudioCtaRow;
